export const server_error_label = {
  "q8fa.services.app.user.registrationFailed.userAlreadyExists":
    "Lo username inserito esiste già",
};
